import React, { useEffect, useState } from 'react';
import { PaperAirplaneIcon } from '@heroicons/react/24/solid';
import { useBreadcrumbs } from '../../../app/breadcrumb-provider';

const AiPage: React.FC = () => {
    const { setBreadcrumbs, setHeaderBorder } = useBreadcrumbs();
    const [query, setQuery] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!query.trim()) return;
        // Handle submission logic here
        console.log('Submitted query:', query);
        setQuery('');
    };

    useEffect(() => {
        setBreadcrumbs([
            { label: 'Ask AI', href: '/ai' }
        ]);
        setHeaderBorder(false);
        return () => setHeaderBorder(true);
    }, [setBreadcrumbs, setHeaderBorder]);


    return (
        <div className="flex flex-col h-full bg-white relative">
            <div className="flex-1 flex flex-col items-center justify-center p-4">
                {/* Title */}
                <h1 className="text-3xl font-bold text-gray-800 mb-8 tracking-tight">
                    Ask MRC AI
                </h1>
                {/* Search Bar Container */}
                <div className="w-full max-w-2xl relative group">
                    {/* Animated Glow Effect */}
                    <div className="absolute -inset-1 bg-gradient-to-r from-[#3B3E81] to-[#E23338] rounded-2xl blur opacity-25 group-hover:opacity-40 transition duration-1000 group-hover:duration-200"></div>

                    <form
                        onSubmit={handleSubmit}
                        className="relative bg-white rounded-2xl shadow-xl flex items-center p-2 border border-gray-100"
                    >
                        <input
                            type="text"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Ask anything..."
                            className="flex-1 bg-transparent border-none outline-none px-4 py-3 text-lg text-gray-700 placeholder-gray-400 w-full"
                        />
                        <button
                            type="submit"
                            disabled={!query.trim()}
                            className={`p-2 rounded-xl transition-all duration-200 ${query.trim()
                                ? 'bg-[#3B3E81] text-white shadow-lg hover:bg-[#2d2f66]'
                                : 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                }`}
                        >
                            <PaperAirplaneIcon className="h-6 w-6" />
                        </button>
                    </form>
                </div>

            </div>

            {/* Footer Disclaimer */}
            <div className="pb-6 text-center text-xs text-gray-400 font-medium">
                MRC AI may make mistakes. Please verify important information.
            </div>
        </div>
    );
};

export default AiPage;
